import React, {Component} from 'react';
import {Badge, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink} from 'reactstrap';
import PropTypes from 'prop-types';

import {AppAsideToggler, AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler} from '@coreui/react';
import logo from '../../assets/img/brand/logo.png'
import sygnet from '../../assets/img/brand/sygnet.png'
import {connect} from "react-redux";

const propTypes = {
    children: PropTypes.node,
};

const defaultProps = {};

const callables = {};

class DefaultHeader extends Component {
    render() {

        // eslint-disable-next-line
        const {children, ...attributes} = this.props;

        return (
            <React.Fragment>
                <AppSidebarToggler className="d-lg-none" display="md" mobile/>
                {/*<AppNavbarBrand*/}
                {/*full={{ src: logo, width: 150, height: 40, alt: 'Mobupps Logo' }}*/}
                {/*minimized={{ src: sygnet, width: 30, height: 30, alt: 'Mobupps Logo' }}*/}
                {/*/>*/}
                <a full="[object Object]" minimized="[object Object]" className="navbar-brand">
                    <img src="/nav_logo.png" width="150" height="40" alt="Logo" className="navbar-brand-full"/>
                    <img src="/nav_logo.png" width="30" height="30" alt="Logo" className="navbar-brand-minimized"/></a>
                <AppSidebarToggler className="d-md-down-none" display="lg"/>

                <Nav className="ml-auto" navbar>
                    <AppHeaderDropdown direction="down">
                        <DropdownToggle nav>
                            <img src={Object.keys(this.props.agentInfo).length ? this.props.agentInfo.profilePicture : 'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg'} className="img-avatar"
                                 alt={Object.keys(this.props.agentInfo).length ? this.props.agentInfo.name : ''}/>
                        </DropdownToggle>
                        <DropdownMenu right style={{right: 'auto'}}>
                            <DropdownItem header tag="div" className="text-center"><strong>{Object.keys(this.props.agentInfo).length ? this.props.agentInfo.name.toUpperCase() : ''}</strong></DropdownItem>
                            <DropdownItem><a href="/logout"><i className="fa fa-lock"></i> Logout</a></DropdownItem>
                        </DropdownMenu>
                    </AppHeaderDropdown>
                </Nav>
                {/*<AppAsideToggler className="d-lg-none" mobile />*/}
                {/*<AppAsideToggler className="d-md-down-none" />*/}
            </React.Fragment>
        );
    }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

const mapStateToProps = state => ({
    agentInfo: state.agent.agentInfo
})

export default connect(mapStateToProps, callables)(DefaultHeader);